
export class Util {

    static randomName(){
        return "guest-" + Math.floor(Math.random() * 10000);
    }

    
}